import styled from '@emotion/styled';

export const Container = styled.div`
  display: flex;
  gap: 32px;
  height: 100%;
  flex-direction: row;
  margin-top: 20px;
`;

export const ProductDetails = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  border-radius: 15px;
  box-shadow: rgba(90, 90, 90, 0.35) 0px 5px 15px;
  width: 250px;
  background: white;
  gap: 8px;
  justify-content: space-between;
`;
